export default __webpack_public_path__ + "static/media/my_turn.6593312b.mp3";